import './App.css';
import "bootstrap-icons/font/bootstrap-icons.css";
import NewReviewPage from './pages/NewReviewPage';
import ReviewsPage from './pages/ReviewsPage';
import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import MrlHeader from './Components/MrlHeader';
import MrlFooter from './Components/MrlFooter';

function App() {
	return (
		<>
			<MrlHeader />
			<Router>
				<Routes basename={'/recensioni'}>					
					<Route exact path={`${process.env.PUBLIC_URL}/`} element={<ReviewsPage />} />					
					<Route path={`${process.env.PUBLIC_URL}/new`} element={<NewReviewPage />} />
				</Routes>
			</Router>			
			<MrlFooter />
		</>
	);
}

export default App;
